

<div class="main-content">
  <div class="page-header">
    <h1 class="page-title">Order History</h1>
  </div>
  @if (customersDataList$ | async; as detail) {
    <div class="account-info">
      Account #, Name, City: {{detail[0].customerNumber}} -{{detail[0].customerName}} - {{detail[0].city}}
    </div>
  }
  <form [formGroup]="orderHistorySearchForm" (ngSubmit)="submitForm()" class="search-filters">
    <div class="filter-row">
      <div class="filter-group">
        <label class="filter-label">{{ 'orderHistorySearchForm.label.salesOrderNumber' | cxTranslate }}</label>
        <input type="text" class="filter-input"
          [placeholder]="'orderHistorySearchForm.label.salesOrderNumber' | cxTranslate"
          formControlName="salesOrderNumber" />
        </div>
        <div class="filter-group">
          <label class="filter-label">{{ 'orderHistorySearchForm.label.purchaseOrderNumber' | cxTranslate }}</label>
          <input type="text" class="filter-input"
            [placeholder]="'orderHistorySearchForm.label.purchaseOrderNumber' | cxTranslate"
            formControlName="purchaseOrderNumber" />
          </div>

          <div class="filter-group">
            <label class="filter-label" for="order-type-filter">
              {{ 'orderHistorySearchForm.label.orderType' | cxTranslate }}
            </label>
            <ng-select id="order-type-filter" [items]="orderTypeList$ | async" [clearSearchOnAdd]="true"
              [closeOnSelect]="true" formControlName="orderType" [bindLabel]="'Text'" [ngModel]="pOrderType"
              [searchable]="false" [placeholder]="'orderHistorySearchForm.label.orderType' | cxTranslate ">
              <ng-template ng-option-tmp let-item="item">
                <div>{{ item['Text'] }}</div>
              </ng-template>
            </ng-select>
          </div>

          <div class="filter-group">
            <label class="filter-label" for="credit-status-filter">
              {{ 'orderHistorySearchForm.label.creditStatus' | cxTranslate }}
            </label>
            <ng-select id="credit-status-filter" [items]="creditStatusList$ | async" [clearSearchOnAdd]="true"
              [closeOnSelect]="true" [searchable]="false" formControlName="creditStatus" [bindLabel]="'Text'"
              [ngModel]="pCreditStatus" [placeholder]="'orderHistorySearchForm.label.creditStatus' | cxTranslate ">
              <ng-template ng-option-tmp let-item="item">
                <div>{{ item['Text'] }}</div>
              </ng-template>
            </ng-select>
          </div>

          <!-- ----------------delivery---------- -->
          <div class="filter-group">
            <label class="filter-label" for="delivery-block-filter">
              {{ 'orderHistorySearchForm.label.deliveryBlock' | cxTranslate }}
            </label>
            <ng-select id="delivery-block-filter" [items]="deliveryBlockList$ | async" [clearSearchOnAdd]="true"
              [closeOnSelect]="true" clearAllText="Clear" formControlName="deliveryBlock" [bindLabel]="'Text'"
              [ngModel]="pDeliveryBlock" [searchable]="false" [placeholder]="'orderHistorySearchForm.label.deliveryBlock' | cxTranslate ">
              <ng-template ng-option-tmp let-item="item">
                <div>{{ item['Text'] }}</div>
              </ng-template>
            </ng-select>
          </div>

          <!-- --------order Status------------ -->
          <div class="filter-group">
            <label class="filter-label" for="status-filter">
              {{ 'orderHistorySearchForm.label.status' | cxTranslate }}
            </label>
            <ng-select id="status-filter" [items]="orderStatusList$ | async" [clearSearchOnAdd]="true"
              [closeOnSelect]="true" clearAllText="Clear" formControlName="status" [bindLabel]="'Text'" [ngModel]="pStatus"
              [searchable]="false" [placeholder]="'orderHistorySearchForm.label.status' | cxTranslate ">
              <ng-template ng-option-tmp let-item="item">
                <div>{{ item['Text'] }}</div>
              </ng-template>
            </ng-select>
          </div>


        </div>

        <!-- Row 2 -->
        <div class="filter-row row-2">
          <div class="filter-group">
            <label class="filter-label">{{ 'orderHistorySearchForm.label.productNumber' | cxTranslate }}</label>
            <input type="text" class="filter-input"
              [placeholder]="'orderHistorySearchForm.label.productNumber' | cxTranslate" formControlName="productNumber" />
            </div>

            <div class="filter-group">
              <label class="filter-label">{{ 'orderHistorySearchForm.label.productName' | cxTranslate }}</label>
              <input type="text" class="filter-input" [placeholder]="'orderHistorySearchForm.label.productName' | cxTranslate"
                formControlName="productName" />
              </div>

              <div class="datepicker-wrapper">
                <label class="filter-label" for="date-from">
                  {{ 'invoiceSearchForm.label.from' | cxTranslate }}
                </label>
                <input id="date-from" class="filter-input res-input"
                  [placeholder]="'invoiceSearchForm.label.from' | cxTranslate" name="fromDate" ngbDatepicker
                  #fromDate="ngbDatepicker" formControlName="_startDate" [readonly]="true" [maxDate]="maxStartDate()"
                  (dateSelect)="onDateChange($event, 'fDate')" (click)="fromDate.toggle()" container="body" />
                  <i class="far fa-calendar-alt calendar-icon" (click)="fromDate.toggle()"></i>

                  <!-- <div *ngIf="orderHistorySearchForm.controls['_startDate'].errors?.required" class="error-message">
                  Please select from date
                </div> -->
              </div>


              <div class="datepicker-wrapper">
                <label class="filter-label" for="date-to">
                  {{ 'invoiceSearchForm.label.to' | cxTranslate }}
                </label>
                <input id="date-to" class="filter-input res-input" [placeholder]="'invoiceSearchForm.label.to' | cxTranslate"
                  name="endDate" ngbDatepicker #endDate="ngbDatepicker" formControlName="_endDate" [readonly]="true"
                  [maxDate]="maxEndDate()" (dateSelect)="onDateChange($event, 'tDate')" (click)="endDate.toggle()"
                  container="body" />
                  <i class="far fa-calendar-alt calendar-icon" (click)="endDate.toggle()"></i>

                  <!-- <div *ngIf="orderHistorySearchForm.controls['_endDate'].errors?.required" class="error-message">
                  Please select to date
                </div> -->
              </div>

              <!-- ----------------brand------------------ -->
              @if (brandSalesShipToList$ | async; as items) {
                <div class="filter-group">
                  <label class="filter-label">{{ 'orderHistorySearchForm.label.brand' | cxTranslate }}</label>
                  <ng-select [items]="items.brand" [clearSearchOnAdd]="true" [closeOnSelect]="true" formControlName="brand"
                    [bindLabel]="'name'" [ngModel]="pBrand" [searchable]="false" [disabled]="true"
                    [placeholder]="'orderHistorySearchForm.label.brand' | cxTranslate">
                  </ng-select>
                </div>
              }
              <!-- ------------ShiptoDestination-------------- -->
              @if (shipToDestinationsList$ | async; as items) {
                <div class="filter-group"  >
                  <label class="filter-label">{{ 'orderHistorySearchForm.label.shipTo' | cxTranslate }}</label>
                  <ng-select [items]="items.shipTo" [clearSearchOnAdd]="true" [closeOnSelect]="true" formControlName="shipTo"
                    bindLabel="labelDesc" [ngModel]="pShipTo" [virtualScroll]="true" [searchable]="false"
                    [placeholder]="'orderHistorySearchForm.label.shipTo' | cxTranslate" appendTo="body" >
                  </ng-select>
                  <!-- <ng-select  [clearSearchOnAdd]="true" [closeOnSelect]="true" formControlName="shipTo"
                  bindLabel="labelDesc" [ngModel]="pShipTo" [virtualScroll]="true" [searchable]="false">
                </ng-select> -->
              </div>
            }
          </div>

          <!-- -------------salesOffice--------------- -->
          <div class="filter-row row-3">
            @if (brandSalesShipToList$ | async; as items) {
              <div class="filter-group">
                <label class="filter-label">{{ 'orderHistorySearchForm.label.salesOffice' | cxTranslate }}</label>
                <ng-select [items]="items.salesOffice" [clearSearchOnAdd]="true" [closeOnSelect]="true"
                  formControlName="salesOffice" [bindLabel]="'name'" [ngModel]="pSalesOffice" [searchable]="false"
                  [placeholder]="'orderHistorySearchForm.label.salesOffice' | cxTranslate">
                </ng-select>
              </div>
            }

            @if (brandSalesShipToList$ | async; as items) {
              <div class="filter-group">
                <label class="filter-label">{{ 'orderHistorySearchForm.label.salesGroup' | cxTranslate }}</label>
                <ng-select [items]="items.salesGroup" [clearSearchOnAdd]="true" [closeOnSelect]="true"
                  formControlName="salesGroup" [bindLabel]="'name'" [ngModel]="pSalesGroup" [searchable]="false"
                  [placeholder]="'orderHistorySearchForm.label.salesGroup' | cxTranslate">
                </ng-select>
              </div>
            }

            <div class="filter-group">
              <label class="filter-label">{{ 'orderHistorySearchForm.label.jobName' | cxTranslate }}</label>
              <input type="text" class="filter-input" [placeholder]="'orderHistorySearchForm.label.jobName' | cxTranslate"
                formControlName="jobName" />
              </div>
            </div>

            <!-- Search Actions -->
            <div class="search-actions">
              <button type="submit" [disabled]="isSearchDisabled$ | async" class="search-btn">
                {{ 'button.search' | cxTranslate }}
              </button>
              <button type="button" (click)="resetForm()" class="reset-btn">
                {{ 'button.reset' | cxTranslate }}
              </button>
            </div>
          </form>
        </div>